<div
  class="w-100 d-flex justify-content-between gap-4 user-select-none align-items-center text-decoration-none"
>
  <div class="d-flex align-items-center">
    <a class="p-2 cursor-pointer" (click)="toggleSidebar()">
      @if (isSidebarVisible$ | async) {
        <ngx-svg-sidebar-close-icon />
      } @else {
        <ngx-svg-sidebar-open-icon />
      }
    </a>
    <ngx-nav-breadcrumb />
  </div>

  @if (logoUrl$ | async; as logoUrl) {
    <img [src]="logoUrl" alt="Binnies HELIX" class="h-100" />
  }

  <div
    class="d-flex gap-3 align-items-center cursor-pointer"
    (click)="userProfileMenu.toggle($event)"
  >
    <div class="d-flex flex-column align-items-end">
      <span>{{ userEmail$ | async }}</span>
      <span [style.font-size]="'0.85rem'">
        {{ (userAppContext$ | async)?.name ?? "-" }}
      </span>
    </div>
    <p-avatar shape="circle" icon="pi pi-user" />
  </div>
</div>

<p-menu
  #userProfileMenu
  [model]="userProfileMenuItems()"
  [popup]="true"
  appendTo="body"
  class="flex"
>
  <ng-template #item let-item>
    <div
      class="d-flex align-items-center justify-content-center"
      [routerLink]="item.routerLink"
    >
      @if (item.icon) {
        <i [class]="item.icon + ' p-3'" [style.font-size]="'1.5rem'"></i>
      }
      <div
        class="d-flex flex-column align-items-center gap-1 p-3 cursor-pointer flex-grow-1"
      >
        <span class="fw-semibold" [style.font-size]="'0.85rem'">
          {{ item.label }}
        </span>
        @if (item.state?.description) {
          <span>{{ item.state.description }}</span>
        }
      </div>
    </div>
  </ng-template>
  <ng-template #end>
    <div
      class="version-info"
      pTooltip="Click to copy to clipboard"
      tooltipPosition="top"
      [cdkCopyToClipboard]="textForClipboard()"
    >
      <div class="d-flex justify-content-between">
        <span>HELIX&trade; Web</span>
        <span>{{ webVersion() }}</span>
      </div>
      <div class="d-flex justify-content-between">
        <span>HELIX&trade; API</span>
        <span>{{ apiVersion() }}</span>
      </div>
    </div>
  </ng-template>
</p-menu>
